import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react"
import { FC } from "react"
import { DeleteIconButton } from "src/components/ui/iconButtons/DeleteIconButton"
import { EditIconButton } from "src/components/ui/iconButtons/EditIconButton"
import { IIncomeCategory } from "src/domain/entities"

export const IncomeCategoryListView: FC<{
	list: IIncomeCategory[]
	onUpdate: (incomeCategory: IIncomeCategory) => void
	onDelete: (incomeCategory: IIncomeCategory) => void
}> = ({ list, onUpdate, onDelete }) => (
	<Table size={"sm"}>
		<Thead>
			<Tr>
				<Th>Name</Th>
				<Th>Slug</Th>
				<Th>Note</Th>
				<Th isNumeric>Actions</Th>
			</Tr>
		</Thead>
		<Tbody>
			{list.map((incomeCategory, i) => (
				<Tr key={i}>
					<Td>{incomeCategory.name}</Td>
					<Td>{incomeCategory.slug}</Td>
					<Td>{incomeCategory.note || "-"}</Td>
					<Td isNumeric>
						<EditIconButton onClick={() => onUpdate(incomeCategory)} />
						<DeleteIconButton onClick={() => onDelete(incomeCategory)} />
					</Td>
				</Tr>
			))}
		</Tbody>
	</Table>
)
